import React from 'react';

export type AppGateState = 'checking' | 'adblock-detected' | 'ready';

interface AdBlockGateContextValue {
  reportAdBlockDetected: () => void;
}

const AdBlockGateContext = React.createContext<AdBlockGateContextValue | null>(null);

export function AdBlockGateProvider({
  children,
  reportAdBlockDetected,
}: React.PropsWithChildren<AdBlockGateContextValue>) {
  return <AdBlockGateContext.Provider value={{ reportAdBlockDetected }}>{children}</AdBlockGateContext.Provider>;
}

const noopAdBlockGate: AdBlockGateContextValue = {
  reportAdBlockDetected: () => {},
};

export function useAdBlockGate() {
  const context = React.useContext(AdBlockGateContext);

  return context ?? noopAdBlockGate;
}
